import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import velocity from 'velocity-animate';
import Notifications from 'vue-notification';
import ComboBox from '@/components/combobox/index.vue';
// import '@mdi/font/css/materialdesignicons.css';
import '/public/css/style.css';

Vue.config.productionTip = false;
Vue.component('combo-box', ComboBox);
Vue.use(Notifications, { velocity });

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
